var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mobile-current-info",attrs:{"justify":"center","no-gutters":""}},[(_vm.selectedRisk !== null)?_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('div',{staticClass:"selected-risk py-1 px-2 mb-1"},[_vm._v(" "+_vm._s(_vm.$t(`risk-${_vm.selectedRisk}`))+" ")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }